import Http from '@/assets/ts/classes/Http'
import Program from '@/assets/ts/interfaces/Program'

/**
 * Get a program by ID.
 *
 * @param id The program ID.
 */
const getProgram = async ( id: number ): Promise<Program> => Http.get( `/program/${id}` )

export default getProgram
